import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
const files = require.context('./modules', false, /\.js$/)
const modules = {}
files.keys().forEach(key => {
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})
Object.keys(modules).forEach(key => {
  modules[key]['namespaced'] = true
})
export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // 管理mutations
  },
  modules,
  plugins: [
    createPersistedState({
      reducer({ course, platform, supervision, term, commom }) {
        return {
          course,
          platform,
          supervision,
          term,
          commom,
        }
      },
    }),
  ],
})
